export default {
    SITE_NAME: 'Glasses.com',
    LOADING_LABEL: 'Loading',
    HEADER_CHECKOUT_TOP_LABEL: 'Secure checkout',
    HEADER_BACK_LABEL: 'Back',
    CART_PAGE_TITLE: 'Your bag',
    EMPTY_PAGE_CLAIM_1: 'Looks like your bag is empty.',
    EMPTY_PAGE_CLAIM_2: 'Get shopping and find that perfect new look.',
    SHOP_EYEGLASSES_LABEL: 'Shop eyeglasses',
    SHOP_SUNGLASSES_LABEL: 'Shop sunglasses',
    LENS_COLOR_PREVIEW_NOT_AVAILABLE: 'Lens preview unavailable',
    LENS_COLOR_PREVIEW_TEXT: 'You will receive the lens color you selected',
    REMOVE_ITEM_LABEL: 'Remove',
    EDIT_ITEM_LABEL: 'Edit',
    SAVE_ITEM_LABEL: 'Save for later',
    CURRENCY_LABEL: '$',
    YOUR_LENSES_LABEL: 'Your lenses',
    FRAME_COLOR_LABEL: 'Frame Color',
    LENS_USE_LABEL: 'Lens use',
    LENS_BRAND_LABEL: 'Lens brand',
    LENS_THICKNESS_LABEL: 'Lens thickness',
    LENS_TREATMENT_LABEL: 'Lens treatments',
    PROMO_APPLIED_LABEL: 'Promo applied',
    PRICE_LABEL: 'Price',
    REMOVE_LABEL: 'Remove',
    SUMMARY_LABEL: 'Summary',
    ITEM_SUMMARY_LABEL_SINGULAR: 'item',
    ITEM_SUMMARY_LABEL_PLURAL: 'items',
    SUBTOTAL_LABEL: 'Subtotal',
    SHIPPING_BOX_TITLE: 'Select a shipping method',
    SHIPPING_TIME_LABEL: 'Shipping timing',
    SHIPPING_TIME_TOOLTIP_HEADER:
        'Shipping times apply only after the prescription verification and manufacturing processes.',
    SHIPPING_BOX_STELLA_ALERT:
        'Unfortunately we cannot currently ship Meta AI Glasses to Puerto Rico',
    SHIPPING_BOX_SAFETY_ALERT:
        'Unfortunately we cannot currently ship Safety Glasses to Puerto Rico',
    REQUIRED_PRESCRIPTION_LABEL: 'Prescription eyewear requires',
    REQUIRED_PRESCRIPTION_TEXT: '(up-to) 7 days to process plus shipping.',
    NO_PRESCRIPTION_LABEL: 'Non-prescription requires',
    NO_PRESCRIPTION_TEXT: ' (up-to) 2 days to process plus shipping.',
    SHIPPING_CLAIM_LABEL:
        'Estimated delivery dates are calculated on the basis that your prescription is sent today.',
    FREE_SHIPPING_LABEL: 'Free',
    INSURANCE_LABEL: 'Insurance',
    USE_INSURANCE_LABEL: 'Apply insurance benefits',
    LOADING_INSURANCE_LABEL: 'Loading insurance',
    INSURANCE_LOADED_LABEL: 'Insurance synced',
    INSURANCE_LOADED_VIEW_BENEFITS: 'View Benefits',
    INSURANCE_ERROR_LABEL: 'Insurance error',
    INSURANCE_NOT_APPLICABLE_ERROR: 'Insurance not applicable',
    ITEM_NOT_INSURABLE_LABEL: 'Please add prescription lenses to use your insurance benefits.',
    REMOVE_INSURANCE_LABEL: 'Remove insurance',
    LOADING_INSURANCE_CLAIM: 'It can take up to 40 seconds',
    ESTIMATED_TAX_LABEL: 'Estimated Tax',
    CALCULATE_TAX_LABEL: 'Calculate',
    CALCULATE_TAX_PLACEHOLDER: 'Enter your Zip code to calculate',
    CALCULATE_TAX_BUTTON_LABEL: 'Calculate',
    RECALCULATE_TAX_BUTTON_LABEL: 'Recalculate',
    PAYMENT_METHODS_CLAIM: 'Pay over time with PayPal, Affirm and Klarna. ',
    PAYMENT_METHODS_CLAIM_NO_KLARNA: 'Pay over time with PayPal or Affirm. ',
    PAYMENT_METHODS_LABEL: 'Or express checkout with',
    LEARN_MORE_PAYMENT_LABEL: 'Learn more',
    TAX_EXCLUDED_LABEL: 'Excl. Tax',
    TAX_INCLUDED_LABEL: 'Incl. Tax',
    TOTAL_LABEL: 'Total',
    CHECKOUT_LABEL: 'Secure checkout',
    APPLE_PAY_LABEL: 'Checkout with',
    RIGHTS_LABEL:
        'By clicking on one of the buttons above you agree to {SITE_NAME} {TERMS_AND_CONDITION} and {PRIVACY_POLICY}',
    TERMS_CONDITION_LABEL: 'Terms and Conditions',
    PRIVACY_LABEL: 'Privacy Policy',
    FSA_LABEL: 'We accept FSA/HSA cards for payments',
    PROMO_LABEL_SHIPPING: 'Promo',
    PROMO_FIELD_NAME: 'promo code',
    PROMO_TITLE: 'Add promo code',
    PROMO_LABEL: 'Enter your promo code',
    PROMO_BUTTON: 'Apply',
    PROMO_ERROR: 'Promo code {PROMO_CODE} is invalid.',
    PROMO_ERROR_INSURANCE: 'Promo code {PROMO_CODE} is not compatible with insurance.',
    PROMO_SUCCESS: 'Your promo code has been applied!',
    SPECIAL_DISCOUNT_TITLE: 'Military, First Responders, Teachers and Government Discount',
    FAQ_TITLE: 'FAQs',
    FAQ_CLAIM: 'Have a question and need an answer quickly? Find it here!',
    SHIPPING_PAGE_TITLE: 'Shipping information',
    CHECKOUT_STEP1_LABEL: 'Shipping',
    CHECKOUT_STEP2_LABEL: 'Payment',
    CHECKOUT_STEP3_LABEL: 'Thank you',
    SKIP_THIS_STEP_LABEL: 'Skip this step with express checkout',
    LOGIN_LABEL: 'Already a customer?',
    LOGIN_LINK: 'Sign in',
    DELIVERY_EMAIL_LABEL: 'E-mail address',
    DELIVERY_FIRST_NAME_LABEL: 'First name',
    DELIVERY_LAST_NAME_LABEL: 'Last name',
    DATE_OF_BIRTH_LABEL: 'Date of birth',
    INVALID_FIELD_VALUE: 'Invalid value for {FIELD_NAME} field',
    DATE_OF_BIRTH_FORMAT: '(MM/DD/YYYY)',
    DATE_OF_BIRTH_CLAIM: 'Only used to send you special birthday promotions',
    DELIVERY_PHONE_LABEL: 'Phone E.g. (123) 456-7890 ',
    DELIVERY_PHONE_CLAIM: "We'll only use it if there are issues with your order",
    DELIVERY_ADDRESS_LABEL: 'Street Address',
    DELIVERY_ADDRESS2_LABEL: 'C/O, Apartment, Floor (Optional)',
    DELIVERY_ADDRESS_CLAIM: 'We cannot deliver to PO Boxes at this time',
    DELIVERY_DETAILS_LABEL: 'Add C/O, Apartment, Floor',
    DELIVERY_ZIPCODE_LABEL: 'Zipcode',
    DELIVERY_CITY_LABEL: 'City',
    DELIVERY_STATE_LABEL: 'State',
    BILLING_CHECKBOX_LABEL: 'Use this address for Billing',
    SMS_CHECKBOX_LABEL:
        'I would like to receive texts from Glasses.com (Yes, I agree to these terms).',
    SMS_TERMS_LABEL:
        'By checking the box I provide my signature expressly consenting to contact from Glasses.com at the number I provided regarding products or services, including marketing and promotions, via live or automated text.  I understand that I am not required to enter into this agreement as a condition of any purchase.  I can revoke this consent by replying STOP. I understand that message frequency varies and that message and data rates may apply.  I also agree to the information provided at the following links - {CONDITIONS}',
    SMS_TERMS_CONDITION_LABEL: 'Terms',
    SMS_TERMS_PRIVACY_LABEL: 'Privacy',
    BILLING_ADDRESS_LABEL: 'Billing information',
    BILLING_FIRST_NAME_LABEL: 'First Name',
    BILLING_LAST_NAME_LABEL: 'Last Name',
    BILLING_ADDRESS1_LABEL: 'Street address',
    BILLING_ADDRESS2_LABEL: 'C/O, Apartment, Floor (Optional)',
    BILLING_ZIPCODE_LABEL: 'Zipcode',
    BILLING_CITY_LABEL: 'City',
    BILLING_STATE_LABEL: 'State',
    PAYMENT_BUTTON_LABEL: 'Proceed to payment',
    PAYMENT_ACCEPTANCE_RIGHTS_LABEL:
        'By proceeding to payment you agree to {SITE_NAME} {CONDITIONS}, {PRIVACY} and {COOKIES}, and consent to receive email with news and offers about our products.',
    CONDITIONS_USE_SALE_LABEL: 'Conditions of Use & Sale',
    PRIVACY_NOTICE_LABEL: 'Privacy Notice',
    COOKIES_LABEL: 'Cookies & Internet Advertising',
    SHOW_SUMMARY_CART_LABEL: 'Show order summary',
    COMPACT_CART_TITLE: 'My cart',
    COMPACT_CART_CTA: 'Edit',
    COMPACT_CART_QUANTITY_LABEL: 'Quantity',
    COMPACT_CART_PRICE_LABEL: 'Price',
    PAYMENT_PAGE_TITLE: 'Select your preferred payment method',
    EXPRESS_DELIVERY_LABEL: 'Express delivery',
    GREEN_SHIPPING_LABEL: 'Responsible shipping',
    RESPONSIBLE_SHIPPING_LABEL: 'Responsible shipping',
    STANDARD_DELIVERY_LABEL: 'Standard shipping',
    GREEN_SHIPPING_TOOLTIP_LABEL:
        'This shipping option is fulfilled by logistics providers using sustainable solutions to reduce climate impact. Delivery may take up to 7 business days.',
    ESTIMATED_DELIVERY_DATE_LABEL: 'Est. date',
    FIELD_REQUIRED_LABEL: 'The {FIELD_NAME} field cannot be empty',
    EMAIL_ERROR_LABEL: 'Please enter a valid email address.',
    ONLY_TEXT_ERROR: 'Please enter letters only.',
    ONLY_NUMBER_ERROR: 'Please enter numbers only.',
    CREDIT_CARD_PAYMENT_TITLE: 'Credit card',
    CREDIT_CARD_PAYMENT_CLAIM: 'We accept FSA/HSA cards for payments',
    CREDIT_CARD_SECURE_PAYMENT_LABEL: 'Secure credit card payment',
    CREDIT_CARD_PAYMENT_NAME_LABEL: 'Card holder name',
    CREDIT_CARD_PAYMENT_CLAIM_LABEL: 'Exactly as shown your card',
    CREDIT_CARD_PAYMENT_CARD_NUMBER_LABEL: 'Card number',
    CREDIT_CARD_EXPIRATION_DATE_LABEL: 'Expiration date',
    SELECT_LABEL: 'Select',
    CREDIT_CARD_SECURITY_LABEL: 'CVV (Security code)',
    CREDIT_CARD_FIND_SECURITY_LABEL: 'Where can I find the security code?',
    PAY_CONFIRM_BUTTON_LABEL: 'Pay and confirm',
    AFFIRM_CLAIM_LABEL: 'Checkout with affirm',
    AFFIRM_TEXT_LABEL:
        'After clicking "PAY WITH AFFIRM" you will be redirected to Affirm checkout to complete your purchase securely. Upon successful completion, you will come back to Costadelmar.com.',
    AFFIRM_BUTTON_LABEL: 'pay with affirm',
    PAYPAL_PAYMENT_LABEL: 'Pay Now or Pay Later',
    PAYPAL_INSTALLMENTS_LABEL: 'PayPal',
    PAYPAL_CLAIM_LABEL: 'What is PayPal?',
    PAYPAL_TEXT_LABEL_PART1: 'By proceeding you agree to {SITE_NAME}',
    PAYPAL_TEXT_LABEL_PART2: '{TERM_AND_CONDITION_PAYPAL} and {PRIVACY_POLICY_PAYPAL}',
    TERM_AND_CONDITION_PAYPAL: 'Terms and Conditions',
    PRIVACY_POLICY_PAYPAL: 'Privacy Policy',
    PAYPAL_REDIRECT:
        'You will be redirected to PayPal, where you can pay and complete your order. ',
    PAYPAL_CONFIRM_PAYMENT_LABEL: 'Pay and confirm',
    PAYPAL_ACCOUNT_LABEL: 'PayPal account',
    PAYPAL_AMOUT_LABEL: 'Amount to be billed',
    PAYPAL_BUTTON_LABEL: 'PayPal paga adesso',
    APPLE_PAYMENT_LABEL: 'Apple Pay',
    AFFIRM_PAYMENT_LABEL: 'Pay over time with Affirm',
    AFTERPAY_PAYMENT_LABEL: '3 interest-free payments with Afterpay',
    TYP_PAGE_TITLE: 'Thank you!',
    TYP_SHIPPING_LABEL: 'Shipping method:',
    TYP_DELIVERY_LABEL: 'Delivery to',
    TYP_TAXES_LABEL: 'Taxes',
    TYP_PAYMENT_LABEL: 'Payment method',
    TYP_TOTAL_LABEL: 'Total',
    TYP_CONTINUE_SHOPPING_LABEL: 'Continue shopping',
    TYP_ORDER_CONFIRMATION_LABEL: "We've sent a confirmation email with your order details to ",
    TYP_SIGNIN_LABEL:
        '{SIGN_IN} or {CREATE_ACCOUNT} for additional benefits like order tracking and faster checkout in just one click',
    TYP_SIGNIN_LINK_LABEL: 'Sign in',
    TYP_CREATE_ACCOUNT_LABEL: 'create an account',
    TYP_ORDER_NUMBER_LABEL: 'Order number',
    TYP_ORDER_DATE_LABEL: 'Order date',
    TYP_PRODUCT_PRESCRIPTION_OK: 'Prescription added',
    TYP_PRESCRIPTION_CLAIM: "We'll do the rest!",
    TYP_SEE_DETAILS_LABEL: 'See details',
    TYP_OPTHY_LABEL: 'If you enjoyed using Opthy, please {LEAVE_REVIEW} in the App Store.',
    TYP_OPTHY_REVIEW: 'leave a review',
    TYP_PRESCRIPTION_MISSING_LABEL: 'Prescription is missing',
    TYP_PRESCRIPTION_REQUESTED_TITLE: 'In order to process your order, we need your prescription.',
    TYP_PRESCRIPTION_REQUESTED_WARNING:
        'If we don’t receive it within 10 days, your order will be automatically canceled.',
    TYP_SEND_PRESCRIPTION_BUTTON: 'Send prescription',
    TYP_PRESCRIPTION_TITLE:
        'Scan or take a picture of your prescription and upload it in digital format',
    TYP_PRESCRIPTION_FORM_CLAIM: 'Accepted formats: jpg, pdf, png / Max size: 10MB',
    TYP_UPLOAD_BUTTON_LABEL: 'Upload file',
    JANUARY_LABEL: 'January',
    FEBRUARY_LABEL: 'February',
    MARCH_LABEL: 'March',
    APRIL_LABEL: 'April',
    MAY_LABEL: 'May',
    JUNE_LABEL: 'June',
    JULY_LABEL: 'July',
    AUGUST_LABEL: 'August',
    SEPTEMBER_LABEL: 'September',
    OCTOBER_LABEL: 'October',
    NOVEMBER_LABEL: 'November',
    DECEMBER_LABEL: 'December',
    CVN_POPUP_TITLE: 'What is a Card Verification Number (CVN)?',
    CVN_POPUP_TEXT_1: "This is your card's authentication number to safe guard against fraud.",
    CVN_POPUP_TEXT_2:
        'This number is printed in the signature area of the back of the card. It is the last 3 digits AFTER the credit card number.',
    DELIVERY_ADDRESS_BOX_TITLE: 'Delivery address',
    DELIVERY_ADDRESS_BACK_LINK_LABEL: 'Edit',
    BILLING_ADDRESS_BOX_TITLE: 'Billing address',
    BILLING_ADDRESS_BACK_LINK_LABEL: 'Edit',
    CREDIT_CARD_NUMBER_INVALID: 'The credit card is invalid',
    CREDIT_CARD_CVV_REQUIRED: 'The card verification number is invalid',
    INSTALMENTS_MODAL_TITLE: 'Shop now. Pay later.',
    INSTALMENTS_MODAL_CLAIM:
        'Select <b>{AFFIRM_LABEL}</b>{OR_KLARNA} <b>{KLARNA_LABEL}</b> or <b>{PAYPAL_PAYMENT_LABEL}</b> as your payment method at checkout <br> to split your purchase into convenient installments.',
    INSTALMENTS_MODAL_CLAIM_MOBILE:
        'Select <b>{AFFIRM_LABEL}</b>{OR_KLARNA} <b>{KLARNA_LABEL}</b> or <b>{PAYPAL_PAYMENT_LABEL}</b> as your payment method at checkout to split your purchase into convenient installments.',
    AFFIRM_LABEL: 'Affirm',
    PRODUCT_RESUME_FRAME_LABEL: 'Frame',
    PRODUCT_RESUME_LENSES_LABEL: 'Lenses',
    PRODUCT_RESUME_WARRANTY_PLAN_LABEL: 'Plan',
    PRODUCT_RESUME_PRESCRIPTION_LABEL: 'Prescription needed',
    PRODUCT_RESUME_PRESCRIPTION_CLAIM: 'We’ll remind you after checkout',
    PRODUCT_RESUME_PRESCRIPTION_OK: 'Prescription added',
    CART_RESUME_SHIPPING_METHOD_LABEL: 'Shipping method',
    CART_RESUME_SHIPPING_EDIT_LABEL: 'Edit',
    CART_RESUME_SUBTOTAL_LABEL: 'Subtotal',
    CART_RESUME_TAX_LABEL: 'Tax',
    CART_RESUME_TOTAL_LABEL: 'Total',
    CART_RESUME_FREE_LABEL: 'Free',
    TOTAL_PRICE_LABEL: 'Total price',
    DELETE_PROMO_CODE_LABEL: 'Delete',
    EDIT_ADDRESS_LABEL: 'Edit',
    PRESCRIPTION_MODAL_TITLE: 'Your prescription details',
    PRESCRIPTION_MODAL_LABEL: 'Prescription',
    PWR_SHP_MODAL_LABEL: 'PWR/ SHP',
    CYL_MODAL_LABEL: 'CYL',
    AXIS_MODAL_LABEL: 'AXIS',
    ADD_MODAL_LABEL: 'ADD',
    DISTANCE_MODAL_LABEL: 'Distance',
    OD_MODAL_LABEL: 'OD',
    OS_MODAL_LABEL: 'OS',
    PRISM_MODAL_LABEL: 'Prism',
    VERTICAL_PRISM_MODAL_LABEL: 'V Prism (A)',
    HORIZONTAL_PRISM_MODAL_LABEL: 'H Prism (A)',
    BASE_DIR_MODAL_LABEL: 'Base Dir',
    NOT_AVAILABLE_LABEL: 'Not available',
    EXTRA_DISCOUNT_LABEL: 'Extra discount',
    IDME_FEEDBACK: 'Your discount has been applied!',
    RESET_PROMO_CODE_LABEL: 'Reset promo code',
    PAYPAL_MODAL_TITLE: 'Pay with PayPal - Safer. More comfortable. Easier.',
    PAYPAL_MODAL_CLAIM:
        'PayPal allows you to pay, send money and accept payments without sharing your card details.',
    PAYPAL_MODAL_FIRST_PARAGRAPH_TITLE: 'Safer',
    PAYPAL_MODAL_FIRST_PARAGRAPH_TEXT:
        'Your security is our priority. We apply automatic encryption to confidential data that is sent between your computer and PayPal servers. In addition, our anti-fraud team controls transactions 24 hours a day, 7 days a week.',
    PAYPAL_MODAL_SECOND_PARAGRAPH_TITLE: 'More comfortable',
    PAYPAL_MODAL_SECOND_PARAGRAPH_TEXT:
        'It is the seller who pays a small fee to handle the payment in complete safety. No matter where you shop or how you choose to pay, when you shop with PayPal there are no additional costs.',
    PAYPAL_MODAL_THIRD_PARAGRAPH_TITLE: 'Easier',
    PAYPAL_MODAL_THIRD_PARAGRAPH_TEXT:
        'PayPal is available in 190 countries: purchases quickly and securely on thousands of Italian and international sites. Choose PayPal as a payment method and you can buy the item in just a few clicks.',
    GREEN_DELIVERY_TOOLTIP_LABEL:
        "We'll ship with logistics providers using sustainable solutions to reduce climate impact.",
    AFFIRM_CLAIM_PAYMENT_LABEL: 'You have chosen to pay in 3 interest-free payment of ',
    SMART_GLASSES_ERROR: 'You can only checkout with one Meta AI Glasses at a time.',
    SMART_GLASSES_CLAIM: 'Please remove any additional frames from your cart.',
    TOO_MANY_GLASSES_ERROR: 'Action required',
    TOO_MANY_GLASSES_CLAIM:
        "Sorry, we can't process Meta AI Glasses with other products in the same transaction. <span><br>Please remove the other item(s) from your cart to proceed.</span>",
    REMOVE_NOW_LABEL: 'Remove Now',
    SESSION_MODAL_TITLE: 'Session expired',
    SESSION_MODAL_TEXT_LINE:
        'For security purpose this session has timed out. Please return to your bag and click on Secure Checkout.',
    SESSION_MODAL_BUTTON_LABEL: 'Go to the bag',
    WELCOME_LABEL: 'Welcome',
    SELECT_ADDRESS_PLACEHOLDER: 'Select an address',
    SELECT_ADDRESS_TOP_LABEL: 'Select an address',
    SMART_GLASSES_MINIMUM_YEARS_OLD_LABEL:
        'You must be 13 years old or above to purchase Meta AI Glasses.',
    EMPTY_ADDRESSES_SELECT_LABEL: 'No addresses available',
    OFF_LABEL: 'off',
    FRAME_PROMO_LABEL: 'frame',
    INSUR_DISCOUNT_LABEL: 'Insurance Discount',
    SMART_GLASSES_INVALID_POSTAL_CODE_LABEL: 'Meta AI Glasses cannot be delivered at this zipcode.',
    SMART_GLASSES_INVALID_STATE_PROVINCE_LABEL:
        'Meta AI Glasses cannot be delivered at this location.',
    SMART_GLASSES_INVALID_ADDRESS_LABEL:
        "Sorry, Meta AI Glasses can't be shipped to this address. Please select an alternative address or remove Meta AI Glasses from your order.",
    INVALID_ZIPCODE_ERROR_LABEL: 'Zip code invalid for this product. Please try using another one.',
    INVALID_PR_ZIPCODE_ERROR_LABEL_1: 'This zip code belongs to Puerto Rico.',
    INVALID_PR_ZIPCODE_ERROR_LABEL_2:
        'We cannot currently ship Meta AI Glasses to Puerto Rico, please select another delivery address.',
    INVALID_STATE_ERROR_LABEL: 'Invalid state for this product.',
    SAFETY_GLASSES_PR_ERROR_LABEL:
        'This zip code belongs to Puerto Rico. We cannot currently ship Safety Glasses to Puerto Rico, please select another delivery address.',
    INVALID_CITY_ERROR_LABEL: 'Invalid city for this product',
    INVALID_PR_STATE_ERROR_LABEL: 'Invalid state for this product.',
    INVALID_PR_CITY_ERROR_LABEL: 'Invalid city for this product',
    NICKNAME_ERROR_LABEL: 'Invalid nickname.',
    GENERIC_ERROR_LABEL: 'Ops! Something went wrong! Please retry.',
    GENERIC_ERROR_MODAL_TITLE: 'Error!',
    GENERIC_ERROR_MODAL_TEXT_LINE: 'Ops! Something went wrong! Please retry.',
    ADDRESS_ERROR_MODAL_TEXT_LINE: 'Invalid address! Please go back to cart and retry.',
    UNDO_MESSAGE_LABEL: ' was removed from your bag.',
    UNDO_LABEL: 'Undo',
    UPLOAD_FILE_SUCCESS_LABEL: 'File is ready for upload',
    UPLOAD_FILE_ERROR_LABEL: 'File size exceeds the maximum allowed',
    WEB_ID_LABEL: 'WebId',
    ADD_NEW_ADDRESS_LABEL: 'Add new address',
    INSURANCE_ONLY_ONE_PRODUCT_ERROR_LABEL:
        "We can't process insurance orders with 2 or more items in the cart. To use your insurance, please reduce the number of items.",
    EMPTY_FILE_ERROR_LABEL: 'Please make sure you have uploaded your file before clicking send',
    KLARNA_PAYMENT_LABEL: '4 interest-free payments with Klarna',
    LABEL_KLARNA_INSTALMENTS_MODAL: 'Click here',
    KLARNA_LABEL: 'Klarna',
    PAY_CONFIRM_KLARNA_BUTTON_LABEL: 'Pay and confirm',
    KLARNA_WIDGET_ERROR: 'There was an error loading Klarna Payment Widget.',
    INSTALMENTS_BOTTOM_LABEL:
        'You must be over 18, a resident of the U.S., and meet additional eligibility criteria to qualify. Late fees may apply. {CLICK_HERE_INSTALMENTS} for complete terms. Loans to California residents made or arranged are pursuant to a California Finance Lenders Law.',
    CLICK_HERE_INSTALMENTS: 'Click here',
    KLARNA_TYP_LABEL: 'Klarna',
    RESUME_INSTALMENTS_LABEL: 'Pay over time with PayPal, Affirm ',
    LEARN_MORE_RESUME_INSTALMENTS_LABEL: 'Learn more',
    COLLECT_IN_STORE_LABEL: 'Collect in store',
    BOSS_TITLE_LABEL: 'Find your nearest partner store.',
    COLLECT_TO_STORE_PLACEHOLDER: 'City/State or Zip Code',
    COLLECT_TO_STORE_BUTTON_LABEL: 'Search',
    BOSS_CLAIM_LABEL:
        'Collect your order at one of the 1000+ LensCrafters stores and enjoy free fitting & adjustment from in store specialists.',
    BOSS_SEARCH_ERROR_CHECKOUT_LABEL: 'Select a store to proceed to checkout',
    BOSS_SEARCH_ERROR_ZIP_CODE_LABEL: 'Please enter a zip code, city or state.',
    BOSS_SEARCH_ERROR_LABEL: 'No store found. Please enter a zip code, city or state.',
    TITLE_BOSS_LABEL: 'Choose a store for delivery',
    SUBTITLE_BOSS_LABEL:
        'Collect your order at one of the 1000+ LensCrafters stores and enjoy free fitting & adjustment from in store specialists.',
    CURRENCY_DISTANCE_LABEL: 'mi',
    GET_DIRECTIONS_LABEL: 'Get directions',
    SEE_HOURS_LABEL: 'See store hours',
    WEEKDAY0: 'Mon',
    WEEKDAY1: 'Tue',
    WEEKDAY2: 'Wed',
    WEEKDAY3: 'Thu',
    WEEKDAY4: 'Fri',
    WEEKDAY5: 'Sat',
    WEEKDAY6: 'Sun',
    BUTTON_DELIVER_LABEL: 'deliver here',
    CHANGE_STORE_BUTTON_LABEL: 'Change store',
    BOSS_SELECTED_CLAIM_LABEL:
        "Once your order has arrived in store, you will be notified when it is ready for pick up. You have 14 days to pick it up before it's automatically returned. At collection, you'll be asked to present your order confirmation email and ID. ",
    SHIPPING_BOSS_PAGE_TITLE: 'Recipient’s details',
    SHIPPING_BOSS_PAGE_SUBTITLE:
        'Please provide the name of the person picking up your order and a contact phone number to receive further assistance. Pick up notification will be sent via email. Present order confirmation and valid ID to collect the order.',
    ADDRESS_CARD_DELIVERY_TITLE: 'Shipping Address:',
    ADDRESS_CARD_BOSS_TITLE: "Recipient's details",
    ADDRESS_CARD_BILLING_TITLE: 'Billing Address:',
    TYP_BOSS_CLAIM_LABEL:
        "Once your order has arrived in store, you will be notified when it is ready for pick up. You have 14 days to pick it up before it's automatically returned. At collection, you'll be asked to present your order confirmation email and ID. ",
    TYP_BOSS_BILLING_LABEL: 'Recipient’s details',
    ADD_WARRANTY_1: 'Add',
    ADD_WARRANTY_2: 'Glasses Protection Plan',
    APPLE_TEXT_LABEL_PART1: 'By continuing you agree to {SITE_NAME}',
    APPLE_TEXT_LABEL_PART2: '{TERM_AND_CONDITION_APPLE} and {PRIVACY_POLICY_APPLE}',
    TERM_AND_CONDITION_APPLE: 'Terms and Conditions',
    PRIVACY_POLICY_APPLE: 'Privacy Policy',
    APPLE_CONFIRM_PAYMENT_LABEL: 'Pay and order',
    APPLE_ACCOUNT_LABEL: 'Apple Pay account',
    APPLE_AMOUT_LABEL: 'Amount to be billed',
    SPEEDY_RX_INFO_NOT_SELECTED:
        'By selecting the 48hr Speedy Delivery option, standard shipping methods will no longer be available.',
    SPEEDY_RX_INFO:
        'When 2-Day Speedy Delivery is active, other shipping methods are not available. Unchecking the 2-Day Speedy Delivery option will display all available standard shipping methods.',
    SPEEDY_RX_CHECK_TITLE: '2-Day Speedy Delivery',
    SPEEDY_RX_CHECK_SUBTITLE: 'Receive your prescription eyewear by',
    SPEEDY_RX_PRICE_LAVEL: '(per product)',
    SPEEDY_RX_TOOLTIP_TITLE: '2-Day Speedy Delivery',
    SPEEDY_RX_TOOLTIP_TEXT:
        'Select this option to receive your single vision prescription eyewear in just two business days.',
    SPEEDY_RX_BANNER_TEXT: '2-Day Speedy Delivery',
    SPEEDY_RX_DETAIL_TEXT: '2-Day Speedy Delivery',
    SPEEDY_INFO_ALASKA_HAWAII: 'Alaska and Hawaii may require more days to ship.',
    SPEEDY_FUNCTIONAL_ERROR_TITLE: 'Adjust your bag to continue',
    SPEEDY_FUNCTIONAL_ERROR_BODY:
        'Not all of the items in your bag are eligible for 2-Day Speedy Delivery. Please remove the item(s) or uncheck the <b>2-Day Speedy Delivery</b> option.',
    SPEEDY_FUNCTIONAL_WARNING_TITLE: 'We’ve made adjustments to your bag',
    SPEEDY_FUNCTIONAL_WARNING_BODY:
        'We cannot process products with different shipping methods. To ensure a seamless delivery, we’ve updated all the items in your bag to <b>2-Day Speedy Delivery.</b>',
};
